import { render } from "./functionDesk.vue?vue&type=template&id=ccbc5a84&scoped=true"
import script from "./functionDesk.vue?vue&type=script&scoped=true&lang=js"
export * from "./functionDesk.vue?vue&type=script&scoped=true&lang=js"

import "./functionDesk.vue?vue&type=style&index=0&id=ccbc5a84&scoped=true&lang=css"

import exportComponent from "D:\\site\\online-photo\\watermark-remover-spa\\tipard.com\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccbc5a84"]])

export default __exports__